import PillarPlaceholder from "./PillarPlaceholder";

export default function ServiceSettings() {
  return (
    <PillarPlaceholder
      pillar="service"
      title="Service settings"
      description="Service-pillar knobs (job-card workflow, ticket categories, SLA defaults, escalation paths) will live here once they're configurable."
    />
  );
}
